import type { Card /* CardType */ } from "@apac/checkout";
import { CardType } from "@hsbc/utilities";

export const hsbcCardMap: Record<string, Card> = {
  461721: {
    type: CardType.CreditCard,
    name: "Advance Platinum",
    incentives: [],
  },
  512042: {
    type: CardType.CreditCard,
    name: "Premier",
    incentives: [],
  },
  486269: {
    type: CardType.CreditCard,
    name: "Visa Platinum",
    incentives: [],
  },
  461709: {
    type: CardType.CreditCard,
    name: "MakeMyTrip Signature",
    incentives: [],
  },
  461716: {
    type: CardType.CreditCard,
    name: "MakeMyTrip Platinum",
    incentives: [],
  },
  456719: {
    type: CardType.CreditCard,
    name: "Visa Gold",
    incentives: [],
  },
  438459: {
    type: CardType.CreditCard,
    name: "HSBC Taj",
    incentives: [],
  },
  356194: {
    type: CardType.CreditCard,
    name: "RuPay Platinum",
    incentives: [],
  },
  356108: {
    type: CardType.CreditCard,
    name: "RuPay Cashback",
    incentives: [],
  },
  456342: {
    type: CardType.CreditCard,
    name: "Classic",
    incentives: [],
  },
  542207: {
    type: CardType.CreditCard,
    name: "Classic",
    incentives: [],
  },
  540259: {
    type: CardType.CreditCard,
    name: "Master Gold",
    incentives: [],
  },
  554851: {
    type: CardType.CreditCard,
    name: "Master Gold Global",
    incentives: [],
  },
  554837: {
    type: CardType.CreditCard,
    name: "Master Classic Global",
    incentives: [],
  },
  447692: {
    type: CardType.CreditCard,
    name: "Visa Classic Global",
    incentives: [],
  },
  431104: {
    type: CardType.CreditCard,
    name: "Live+",
    incentives: [],
  },
  517782: {
    type: CardType.CreditCard,
    // TODO: There are 2 cards types mapped to this bin, update with we have future info to distinguish
    name: "Credit Card",
    incentives: [],
  },
  428414: {
    type: CardType.DebitCard,
    name: "Premier Debit",
    incentives: [],
  },
  434676: {
    type: CardType.DebitCard,
    name: "Mass Market Debit",
    incentives: [],
  },
  461732: {
    type: CardType.DebitCard,
    // TODO: There are 2 cards types mapped to this bin, update with we have future info to distinguish
    name: "Debit Card",
    incentives: [],
  },
};
